import WebClient from './my-baumit.webclient';
//import { CardSectionService } from '../component/card-section/card-section-common';
import { CardOrganizerService } from '../editor/card-organizer/card-organizer';
import * as $ from 'jquery';

//@if (!$loop->first) hidden @endif"
const dashboardTabTemplate = (id, name) => $(`<div data-dashboard-id="${id}" class="tab-button dashboard-tab" >${name}</div>`);
const dashboardTemplate = (id, renderedCards: Array<string>) => {
    let db = $(`<div data-dashboard-id="${id}" class="dashboard-item ${renderedCards.length == 0 ? 'empty-dashboard' : ''}"><div class="card-organizer no-drag"><div class="grid dashboard"></div></div></div>`);
    db.find('.dashboard').append(
         // $(renderedCards.reduce(function (accumulator, currentValue) {
         //     console.log(accumulator + currentValue);
         //     return accumulator + currentValue;
         // })).filter('.grid-item')
         $(renderedCards.reduce((prev, next) => prev + next, '')).filter('.grid-item')
    );
    return db;
}
const modifyDashboardFormTemplate = (id, name) => 
    `<div class="form-group">
		<input type="text" class="form-control" id="dashboard_${id}_name" name="dashboard_${id}_name"  value="${name}"><span class="mdi mdi-delete"></span>
	</div>`;


const moveToDashboardSelectOptionTemplate = (id, name) =>`<option value="${id}">${name }</option>`;


interface Dashboard {
    id: number,
    user_id: number,
    name: string,
    rendered_cards: Array<any>,
    cards: Array<any>
}

class DashboardCardOrganizer extends CardOrganizerService {

    constructor(private dashboardId: number) {
        super();
    }

    private saveDashboardCards = (cardIds: Array<number>) => WebClient.sortDashboardCards(this.dashboardId, cardIds)

    public init() {
        super.init(this.saveDashboardCards, `[data-dashboard-id=${this.dashboardId}]`, false);
    }



}

export class MyBaumitUI {

    private cardOrganizers: Array<DashboardCardOrganizer>;

    constructor() {
    }

    public init() {
        this.refresh();
        this.initEvents();

    }

    public refresh() {
        this.createDashboard().then(() => {
            $('.dashboard-tab').eq(0).trigger('click');
        });
    }

    public add() {
        this.createDashboard().then(() => {
            let dashboardCnt = $('.grid.dashboard').length;
            $('.dashboard-tab').eq(dashboardCnt - 1).trigger('click');
        });
    }

    private initEvents() {
        $(document).off('click', '.dashboard-tab');
        $(document).on('click', '.dashboard-tab', event => {
            $('[data-dashboard-id] .grid.dashboard').addClass('hidden');
            let target = $(event.target).closest('[data-dashboard-id]');
            let active = $(`[data-dashboard-id=${target.attr('data-dashboard-id')}]`);
            $('.dashboard-tab').removeClass('selected');
            target.addClass('selected');
            active.find('.grid.dashboard').removeClass('hidden');
            if (active.hasClass('empty-dashboard'))
                $('.dashboard-text').show();
            else
                $('.dashboard-text').hide();
        });
    }

    private createDashboard = () => {
        return WebClient.getDashboards().then(result => this.addDashboards(result.dashboards));
    }

    private addDashboards(dashboards: Array<Dashboard>) {

        let tabcontainer = $('.dashboard-tab-container') ;
        let form =  $('#modifyDashboardForm').find('fieldset')
        form.find('.form-group').remove();
        let select = $('#moveToDashboardSelect');
        select.find('option').remove();
        let container = $('.dashboard-container');
        $('.dashboard-tab, .dashboard-item').remove();
        form.html();
        dashboards.forEach(db => {
            tabcontainer.append(dashboardTabTemplate(db.id, db.name));
            container.append(dashboardTemplate(db.id, db.rendered_cards));
            let organizer = new DashboardCardOrganizer(db.id);
            organizer.init();
            container.find('.grid.dashboard').addClass('hidden');
            form.prepend(modifyDashboardFormTemplate(db.id, db.name));
            select.append(moveToDashboardSelectOptionTemplate(db.id, db.name))
        })

    }

}

(window as any).myBaumitUI = new MyBaumitUI();
(window as any).myBaumitUI.init();
